
<template>
  <div>
    <v-layout
      align-end
      justify-end
      mx-0
      px-0
      :class="classAttributes"
    >
      <v-flex
        ma-0
        pa-0
        id="date-range-filter"
        :class="{'md5':!customRangeSelected,'md9':customRangeSelected}"
      >
        <v-md-date-range-picker
          :start-date="selectedDateRangePreset.dateRange.startDate.toString()"
          :end-date="selectedDateRangePreset.dateRange.endDate.toString()"
          opens="right"
          @change="updateDateRange"
          show-custom-range-label
          class="md-date-range-picker"
          :presets="presets"
        >
          <div slot="input">
            <v-icon small>
              $vuetify.icons.calendar_today_outline
            </v-icon>
            <span
              class="custom-range fw-semi-bold"
              v-if="selectedRange=='Custom Range'"
            >
              {{ selectedDateRangePreset.dateRange.startDate.format('ll') }}{{ " - " }}{{ selectedDateRangePreset.dateRange.endDate.format('ll') }}
            </span>
            <span class="other-ranges  fw-semi-bold" v-else>
              {{ selectedRange }}
            </span>
          </div>
        </v-md-date-range-picker>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import moment from 'moment';
import { VIcon, VFlex, VLayout } from 'vuetify/lib';
import { mapActions, mapGetters } from 'vuex';
export default {
  props: ['presetId', 'attach', 'classAttributes'],
  data() {
    return {
      startDate: '',
      endDate: '',
      selectedRange: 'This Month',
      presets: [
        {
          label: 'Last 7 Days',
          range: [moment().subtract(7, 'days'), moment().subtract(1, 'days')]
        },
        {
          label: 'Today',
          range: [moment(), moment()]
        },
        {
          label: 'Last 15 Days',
          range: [moment().subtract(15, 'days'), moment().subtract(1, 'days')]
        },
        {
          label: 'Last 30 Days',
          range: [moment().subtract(30, 'days'), moment().subtract(1, 'days')]
        },
        {
          label: 'This Month',
          range: [moment().startOf('month'), moment()]
        },
        {
          label: 'Last Month',
          range: [
            moment()
              .subtract(1, 'month')
              .startOf('month'),
            moment()
              .subtract(1, 'month')
              .endOf('month')
          ]
        }
      ],
      customRangeSelected: false
    };
  },
  computed: {
    ...mapGetters(['selectedDateRangePreset', 'dateRangePresetOptions'])
  },
  mounted() {
    this.setIsDateRangeUpdated(false);
    let activeRange = document.querySelector('.ranges li.active');
    if (activeRange && activeRange.innerText.trim() == 'Custom Range') {
      this.customRangeSelected = true;
      this.selectedRange =
        this.selectedDateRangePreset.dateRange.startDate.format('ll') +
        ' - ' +
        this.selectedDateRangePreset.dateRange.endDate.format('ll');
    }

    /* Adding click event to custom range*/
    let customRange = this.$el.querySelector('li:last-child');
    customRange.addEventListener(
      'click',
      () => {
        this.clickCustomRange();
      },
      false
    );
    /* Adding click event to other ranges*/
    let otherRanges = this.$el.querySelectorAll('li:not(:last-child)');
    for (var j = 0; j < otherRanges.length; j++) {
      otherRanges[j].addEventListener(
        'click',
        () => {
          this.clickOtherRange();
        },
        false
      );
    }
    /*Changes default library color to app's primary color when page is loaded*/
    let calenderCellContent = document.querySelectorAll(
      'table.calendar-table td.calendar-cell.active .calendar-cell__content'
    );
    if (calenderCellContent) {
      for (var i = 0; i < calenderCellContent.length - 1; i++) {
        calenderCellContent[i].style.backgroundColor = ' var(--v-primary-base)';
      }
    }
    //makes the panel open from the right most corner
    let mdrpRoot = document.querySelector('.mdrp-root');
    if (mdrpRoot) {
      let mdrpRootWidth = parseInt(window.getComputedStyle(mdrpRoot).width, 10);
      let datePickerContianer = document.querySelector(
        '.mdrp__panel.opens-arrow-pos-right'
      );
      if (datePickerContianer)
        datePickerContianer.style.right = '' + mdrpRootWidth / 200 + 'px';
    }
  },
  methods: {
    ...mapActions(['setDateRange', 'setIsDateRangeUpdated']),
    clickCustomRange() {
      var calenderPanel = document.querySelectorAll('.calendar-table');
      //There are two calender's ,hence two calender-table class needs to be changed
      if (calenderPanel) {
        for (var i = 0; i < calenderPanel.length; i++) {
          calenderPanel[i].style.setProperty('display', 'block', 'important');
        }
      }
      // this.selectedDateRangePreset.dateRange.startDate = moment().subtract(
      //   5,
      //   "days"
      // );
      // this.selectedDateRangePreset.dateRange.endDate = moment().subtract(
      //   1,
      //   "days"
      // );
      let calenderCell = document.querySelector(
        'calendar-cell active end-date'
      );
      if (calenderCell) calenderCell.backgroundColor = '#eef4ff !important';
    },
    clickOtherRange() {
      this.customRangeSelected = false;
      var calenderPanel = document.querySelectorAll('.calendar-table');
      //There are two calender's ,hence two calender-table class needs to be changed
      if (calenderPanel)
        for (var i = 0; i < calenderPanel.length; i++) {
          calenderPanel[i].style.setProperty('display', 'none', 'important');
        }
    },
    updateDateRange(value) {
      let calenderCellContent = document.querySelectorAll(
        'table.calendar-table td.calendar-cell.active .calendar-cell__content'
      );
      //Changes default library color to app's primary color on change
      for (var i = 0; i < calenderCellContent.length; i++) {
        calenderCellContent[i].style.backgroundColor = 'var(--v-primary-base)';
      }
      this.$nextTick(() => {
        //selectedRange is used to set the preset to the textbox
        this.selectedRange = document.querySelector(
          '.ranges li.active'
        ).innerText;
        //used for setting md's for customrange
        if (this.selectedRange != 'Custom Range') {
          this.customRangeSelected = false;
        } else {
          this.customRangeSelected = true;
        }
        //Changes default library color to app's primary color on change
        let calenderCellContent = document.querySelectorAll(
          'table.calendar-table td.calendar-cell.active .calendar-cell__content'
        );
        if (calenderCellContent) {
          for (var i = 0; i < calenderCellContent.length; i++) {
            calenderCellContent[i].style.backgroundColor =
              'var(--v-primary-base)';
          }
        }
        var datePickerContianer = document.querySelector('.mdrp__panel');
        if (datePickerContianer)
          datePickerContianer.style.setProperty('display', 'none', 'important');
      });
      if (
        !(
          value[0].isSame(
            this.selectedDateRangePreset.dateRange.startDate,
            'day'
          ) &&
          value[1].isSame(this.selectedDateRangePreset.dateRange.endDate, 'day')
        )
      ) {
        this.setIsDateRangeUpdated(true);
        this.setDateRange(value);
        this.$emit('change');
      }
    }
  },
  components: { VIcon, VFlex, VLayout }
};
</script>

<style scoped>
.md-date-range-picker {
  min-height: 48px;
  width: -webkit-fill-available; /* Added to make expand daterange picker to occupy the whole flex size */
  display: flex !important;
  align-items: center;
  cursor: pointer;
}
.custom-range {
  font-size: 14px;
  white-space: nowrap;
  line-height: 2.6rem;
  margin-left: 0.3rem;
}
.other-ranges {
  font-size: 14px;
  line-height: 2.6rem;
  margin-left: 0.3rem;
}

#date-range-filter {
  background-color: #fff;
  cursor: default;
}
::v-deep .mdrp__activator {
  width: 100%;
}
::v-deep .mdrp__activator .activator-wrapper .text-field {
  border: none;
  font-size: 0.9rem;
}
::v-deep .mdrp__activator .activator-wrapper .text-field:focus ~ label {
  display: none;
}
::v-deep .mdrp__activator .activator-wrapper .text-field ~ label {
  display: none;
}
::v-deep .mdrp__activator .activator-wrapper .bar {
  display: none;
}
::v-deep .mdrp__activator .activator-wrapper {
  width: 14rem;
}
::v-deep .mdrp__panel::before {
  display: none !important;
}
::v-deep .mdrp__panel::after {
  /* used to remove arrow on the top */
  content: none !important;
}
::v-deep .v-icon {
  margin: 0.3vw;
  margin-right: 0.1vw;
  margin-left: 0.8vw;
  padding: 0%;
}
::v-deep .mdrp__panel.opens-arrow-pos-right {
  left: auto !important;
  top: -7px !important;
  max-width: 100vw !important;
  min-width: 13.6vw !important;
  width: fit-content !important;
  right: 0px !important;
}

@media (min-width: 960px) {
  #date-range-filter {
    margin-left: 7.73vw !important ;
  }
}

@media (max-width: 960px) {
  ::v-deep .mdrp__panel.opens-arrow-pos-right {
    left: 0px !important;
    width: 100% !important;
  }
  ::v-deep .ranges {
    order: 2;
    width: inherit !important;
  }
  ::v-deep .v-icon {
    margin-right: 0.5vw;
    margin-left: 2vw;
    margin-top: 0vw;
    padding-bottom: 0.4vw;
  }
  .custom-range {
    font-size: 14px;
    line-height: 29px;
  }
  .other-ranges {
    font-size: 14px;
    line-height: 29px;
  }
}
@media (max-width: 480px) {
  ::v-deep .v-icon {
    margin-left: 4vw;
    margin-right: 1vw;
    margin-top: 0vw;
    padding-bottom: 1.4vw;
  }
}
::v-deep .ranges li.active {
  color: var(--v-primary-base) !important;
}
::v-deep .ranges ul {
  width: inherit !important;
  max-width: inherit !important;
}
::v-deep .mdrp__panel {
  padding-bottom: none !important;
  margin-bottom: 25px !important;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  border-right: 0px;
  border-left: 0px;
}
::v-deep .mdrp__panel .calendar-table {
  display: none !important;
  order: 1;
  padding-left: 1.1rem !important;
}
::v-deep .ranges {
  order: 2;
  width: 14vw;
}
::v-deep
  table.calendar-table
  td.calendar-cell.active
  .calendar-cell__content[data-v-89ba891e] {
  background-color: var(--v-primary-base) !important;
}

::v-deep table.calendar-table td.calendar-cell.active,
table.calendar-table td.calendar-cell.active:hover {
  background-color: #eef4ff !important;
}

::v-deep table.calendar-table td.calendar-cell.off,
table.calendar-table td.calendar-cell.off.end-date,
table.calendar-table td.calendar-cell.off.in-range,
table.calendar-table td.calendar-cell.off.start-date {
  visibility: hidden;
}

::v-deep .mdrp__panel.dropdown-menu {
  z-index: 2 !important;
  transition: none !important;
  transform: none !important;
}
</style>

